import * as Sentry from '@sentry/react';

import { getEnv } from '@luna/env';

import type { LoggerFunction } from './type';

export const captureException: LoggerFunction = (
    message?: unknown,
    ...optionalParams: unknown[]
) => {
    if (!getEnv()?.sentry) {
        return;
    }

    if (message instanceof Error) {
        Sentry.captureException(message);
        return;
    }

    Sentry.captureException(`logger.error: ${message}. Args: ${optionalParams.join(', ')}`);
};
